module.exports = __webpack_public_path__ + "img/black_friday_deal_text_v1.101cdfd.svg";